import React from 'react';

export default function PageFooter() {
  const currentYear = new Date().getFullYear();
  const logoSrc = `${process.env.PUBLIC_URL}/minnesota-state-member-logo.png`;

  return (
    <footer
      style={{
        marginTop: '40px',
        backgroundColor: '#463066',
        color: '#fff',
        padding: '1rem 2rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: '1200px',
          margin: '0 auto',
          gap: '1rem',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={logoSrc}
            alt='Minnesota State. Minnesota State University, Mankato, A member of Minnesota State'
            style={{ height: '50px', marginRight: '1rem' }}
          />
        </div>

        <div
          style={{
            height: '80px',
            borderLeft: '1px solid rgba(255, 255, 255, 0.5)',
            margin: '0 1rem',
          }}
        />

        <div style={{ fontSize: '1rem', textAlign: 'right' }}>
          &copy; 2005-{currentYear} Minnesota State University, Mankato
        </div>
      </div>
    </footer>
  );
}
